@if (iProjectTypeId() === 21) {
  <div style="margin-left: 10px;">
    <div class="float-left" style="display: flex; width: 50%">
      <kendo-dropdownlist class="form-control" [(ngModel)]="projectEstimateId" [ngModelOptions]="{ standalone: true }" [data]="dProjectEstimate"
        [textField]="'DisplayText'" [valueField]="'ProjectEstimateId'" [valuePrimitive]="true"
        (valueChange)="handleEstimateChange($event)">
      </kendo-dropdownlist>
      @if (loading) {
        <kendo-loader type="converging-spinner" size="small" class="loader-margins"></kendo-loader>
      }
    </div>
    <h6 class="card-title">Drill Depth per Day</h6>
    <kendo-chart style="height:360px; margin-bottom: 37px;">
      <kendo-chart-area background="#f9f9f9" [margin]="30">
      </kendo-chart-area>
      <kendo-chart-series>
        <kendo-chart-series-item type="scatterLine" name="Depth" [data]="dProjectEstimatePhaseStepDetail"
          xField="CumulativeDays" yField="DepthEnd">
        </kendo-chart-series-item>
      </kendo-chart-series>
      <kendo-chart-x-axis>
        <kendo-chart-x-axis-item [title]="{ text: 'Days' }" [labels]="{ format: '{0}d' }" [min]="daysMinValue"
          [max]="daysMaxValue">
        </kendo-chart-x-axis-item>
      </kendo-chart-x-axis>
      <kendo-chart-y-axis>
        <kendo-chart-y-axis-item [title]="{ text: 'Depth' }" [labels]="{ format: '{0:n0}' }" [min]="depthMinValue"
          [max]="depthMaxValue" [reverse]="true">
        </kendo-chart-y-axis-item>
      </kendo-chart-y-axis>
      <kendo-chart-tooltip format="{1} feet in {0} days">
      </kendo-chart-tooltip>
    </kendo-chart>
    <br />
    <h6 class="card-title">Cost per Day</h6>
    <kendo-chart style="height:360px">
      <kendo-chart-area background="#f9f9f9" [margin]="30">
      </kendo-chart-area>
      <kendo-chart-series>
        <kendo-chart-series-item type="scatterLine" name="Cost" [data]="dProjectEstimatePhaseStepDetail"
          xField="CumulativeDays" yField="CumulativeCost" color="green">
        </kendo-chart-series-item>
      </kendo-chart-series>
      <kendo-chart-x-axis>
        <kendo-chart-x-axis-item [title]="{ text: 'Days' }" [labels]="{ format: '{0}d' }" [min]="daysMinValue"
          [max]="daysMaxValue">
        </kendo-chart-x-axis-item>
      </kendo-chart-x-axis>
      <kendo-chart-y-axis>
        <kendo-chart-y-axis-item [title]="{ text: 'Cost' }" [labels]="{ format: '{0:c0}' }" [min]="costMinValue"
          [max]="costMaxValue" [reverse]="true">
        </kendo-chart-y-axis-item>
      </kendo-chart-y-axis>
      <kendo-chart-tooltip format="${1:c0} in {0:n2} days">
      </kendo-chart-tooltip>
    </kendo-chart>
  </div>
}

<br />
<h6 class="card-title">Phase / Step Details</h6>

@if (iProjectTypeId() === 22 || iProjectTypeId() === 58 || iProjectTypeId() === 59) {
  <div style="margin-left: 10px;">
   
    <kendo-grid [data]="dProjectEstimatePhaseStepDetail" style="font-size:12px" [scrollable]="'scrollable'">
      <ng-template kendoGridToolbarTemplate>
        <div class="float-left" style="width: 300px" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
          <kendo-dropdownlist class="form-control" style="width: 100%;" [(ngModel)]="projectEstimateId" [ngModelOptions]="{ standalone: true }" [data]="dProjectEstimate"
            [textField]="'DisplayText'" [valueField]="'ProjectEstimateId'" [valuePrimitive]="true"
            (valueChange)="handleEstimateChange($event)">
          </kendo-dropdownlist>
          @if (loading) {
            <kendo-loader type="converging-spinner" size="small" class="loader-margins"></kendo-loader>
          }
        </div>
        <div class="ms-auto">
          <button type="button" themeColor="primary" kendoGridExcelCommand [svgIcon]="icons.export">
            Export
          </button>
        </div>
      </ng-template>
      <kendo-grid-column field="Phase">
      </kendo-grid-column>
      <kendo-grid-column field="Step">
      </kendo-grid-column>
      <kendo-grid-column field="DaysInPhase" title="Days" format="{0:n2}">
      </kendo-grid-column>
      <kendo-grid-column field="CumulativeDays" title="Cumulative Days" format="{0:n2}">
      </kendo-grid-column>
      <kendo-grid-column field="Cost" title="Cost" format="{0:c0}">
      </kendo-grid-column>
      <kendo-grid-column field="CumulativeCost" title="Cumulative Cost" format="{0:c0}">
      </kendo-grid-column>
      <kendo-grid-excel [fileName]="exportFileName"></kendo-grid-excel>
    </kendo-grid>
  </div>
}

@if (iProjectTypeId() === 21) {
  <div style="margin-left: 10px;">
    <kendo-grid [data]="dProjectEstimatePhaseStepDetail" style="font-size:12px" [scrollable]="'scrollable'">
      <ng-template kendoGridToolbarTemplate>
        <div class="ms-auto">
          <button type="button" themeColor="primary" kendoGridExcelCommand [svgIcon]="icons.export">
            Export
          </button>
        </div>
      </ng-template>
      <kendo-grid-column field="Phase">
      </kendo-grid-column>
      <kendo-grid-column field="Step">
      </kendo-grid-column>
      <kendo-grid-column field="DaysInPhase" title="Days" format="{0:n2}">
      </kendo-grid-column>
      <kendo-grid-column field="CumulativeDays" title="Cumulative Days" format="{0:n2}">
      </kendo-grid-column>
      <kendo-grid-column field="DepthStart" title="Start Depth" format="{0:n0}">
      </kendo-grid-column>
      <kendo-grid-column field="DepthEnd" title="End Depth" format="{0:n0}">
      </kendo-grid-column>
      <kendo-grid-column field="Cost" title="Cost" format="{0:c0}">
      </kendo-grid-column>
      <kendo-grid-column field="CumulativeCost" title="Cumulative Cost" format="{0:c0}">
        <!--
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{dataItem.CumulativeCost | currency:'USD':'symbol-narrow' }}
        </ng-template>
        -->
      </kendo-grid-column>
      <kendo-grid-excel [fileName]="exportFileName"></kendo-grid-excel>
    </kendo-grid>
  </div>
}